var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonObject, JsonProperty } from 'json2typescript';
export var ValidationAction;
(function (ValidationAction) {
    ValidationAction["Error"] = "ERROR";
    ValidationAction["Warn"] = "WARN";
})(ValidationAction || (ValidationAction = {}));
export var ValidationLevel;
(function (ValidationLevel) {
    ValidationLevel["Off"] = "OFF";
    ValidationLevel["Moderate"] = "MODERATE";
    ValidationLevel["Strict"] = "STRICT";
})(ValidationLevel || (ValidationLevel = {}));
var ValidationOptions = (function () {
    function ValidationOptions(partial) {
        this.readValidationAction = ValidationAction.Error;
        this.readValidationLevel = ValidationLevel.Off;
        this.writeValidationAction = ValidationAction.Error;
        this.writeValidationLevel = ValidationLevel.Off;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('read_validation_action'),
        __metadata("design:type", String)
    ], ValidationOptions.prototype, "readValidationAction", void 0);
    __decorate([
        JsonProperty('read_validation_level'),
        __metadata("design:type", String)
    ], ValidationOptions.prototype, "readValidationLevel", void 0);
    __decorate([
        JsonProperty('write_validation_action'),
        __metadata("design:type", String)
    ], ValidationOptions.prototype, "writeValidationAction", void 0);
    __decorate([
        JsonProperty('write_validation_level'),
        __metadata("design:type", String)
    ], ValidationOptions.prototype, "writeValidationLevel", void 0);
    ValidationOptions = __decorate([
        JsonObject('ValidationOptions'),
        __metadata("design:paramtypes", [Object])
    ], ValidationOptions);
    return ValidationOptions;
}());
export { ValidationOptions };
//# sourceMappingURL=ValidationOptions.js.map